import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class GetSubsets extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Get Subsets</h1>
				<p>This method returns a list of items that are included in the specified item.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> GET </td>
							<td> {`/items/{type}/{no}/subsets`} </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<table>
					<tbody>
						<tr>
							<th>Parameter Name </th>
							<th>Value </th>
							<th>Optional </th>
							<th>Description </th>
						</tr>
						<tr>
							<td> type </td>
							<td> String </td>
							<td> N </td>
							<td> The type of the item. Acceptable values are:<br/>MINIFIG, PART, SET, BOOK, GEAR, CATALOG, INSTRUCTION, UNSORTED_LOT, ORIGINAL_BOX </td>
						</tr>
						<tr>
							<td> no </td>
							<td> String </td>
							<td> N </td>
							<td> Identification number of the item </td>
						</tr>
						<tr>
							<td> color_id </td>
							<td> Integer </td>
							<td> Y </td>
							<td> The color of the item(This value is valid only for PART type) </td>
						</tr>
						<tr>
							<td> box </td>
							<td> Boolean </td>
							<td> Y </td>
							<td> Indicates whether the set includes the original box </td>
						</tr>
						<tr>
							<td> instruction </td>
							<td> Boolean </td>
							<td> Y </td>
							<td> Indicates whether the set includes the original instruction </td>
						</tr>
						<tr>
							<td> break_minifigs </td>
							<td> Boolean </td>
							<td> Y </td>
							<td> Indicates whether the result breaks down minifigs as parts </td>
						</tr>
						<tr>
							<td> break_subsets </td>
							<td> Boolean </td>
							<td> Y </td>
							<td> Indicates whether the result breaks down sets in set </td>
						</tr>
					</tbody>
				</table>
				<h4>Request body</h4>
				<p>Do not supply a request body with this method.</p>
				<h4>Response</h4>
				<p>If successful, this method returns a nested list of <a href="?page=resource-representations-catalog">subset entries</a> as "data" in the response body. Note that the result is grouped by matching. An inner list indicates one matching group of items.</p>
				<h4>Example</h4>
				<ul>
					<li>
						GET /items/set/7644-1/subsets
						<ul>
							<li>Retrieves a list of items that are included in the SET #7644-1</li>
						</ul>
					</li>
					<li>
						GET /items/set/7644-1/subsets?instruction=true&break_minifigs=false
						<ul>
							<li>Retrieves a list of items that are included in the SET #7644-1 including the instruction and breaking down minifigs as parts</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}